import React from 'react';
import type { IconComponentProps } from '@/types/components';

export const DocxIcon: React.FC<IconComponentProps> = ({ className }) => (
  <svg
    className={className}
    width="77"
    height="76"
    viewBox="0 0 77 76"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="docx-icon-mask"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="77"
      height="76"
    >
      <rect width="77" height="76" rx="4" fill="#D9D9D9" />
    </mask>
    <g mask="url(#docx-icon-mask)">
      <rect x="-10" y="-6" width="97" height="87" fill="#E0F3FF" />
      <path
        d="M42.2532 18H27.2269C25.7801 18 24.6006 19.1795 24.6006 20.6341V55.6328C24.6006 57.0874 25.78 58.259 27.2347 58.2669H53.6154C55.0701 58.2669 56.2417 57.0874 56.2495 55.6328L56.1709 29.6374L42.2532 18Z"
        fill="#4EB3F2"
      />
      <path
        d="M42.2546 18L42.2153 29.3622C42.2153 29.3622 42.2546 29.6374 42.4905 29.6374H56.1723L42.2546 18Z"
        fill="#0077CC"
      />
      <path
        d="M22.0694 37.3982H48.6152C49.2049 37.3982 49.6846 37.8778 49.6846 38.4676V50.3251C49.6846 50.9149 49.2049 51.3945 48.6152 51.3945H22.0694C21.4796 51.3945 21 50.9149 21 50.3251V38.4676C21 37.8778 21.4796 37.3982 22.0694 37.3982Z"
        fill="#0077CC"
      />
      <path
        d="M22.6182 41.5193H25.3231C25.8578 41.5193 26.2902 41.5901 26.6126 41.7395C26.9271 41.8731 27.2102 42.0933 27.4225 42.3606C27.6427 42.6358 27.7999 42.9582 27.8864 43.3042C27.9808 43.6738 28.0358 44.0591 28.028 44.4444C28.028 45.0734 27.9572 45.5609 27.8157 45.9069C27.682 46.2371 27.4776 46.5359 27.2181 46.7797C26.99 46.9999 26.707 47.1571 26.3924 47.2436C26.0386 47.3458 25.6769 47.393 25.3073 47.4009H22.6182V41.5193ZM24.4345 42.856V46.072H24.8827C25.2602 46.072 25.5354 46.0327 25.6926 45.9462C25.8656 45.844 25.9993 45.6946 26.0701 45.5059C26.1566 45.2936 26.2037 44.9555 26.2037 44.4837C26.2037 43.8625 26.1015 43.43 25.8971 43.202C25.6926 42.974 25.3545 42.856 24.8827 42.856H24.4345Z"
        fill="white"
      />
      <path
        d="M28.7583 44.4676C28.7583 43.5083 29.0256 42.7613 29.5603 42.2188C30.095 41.6841 30.842 41.4167 31.8013 41.4167C32.7842 41.4167 33.5391 41.6762 34.0659 42.2031C34.5927 42.7299 34.8601 43.4612 34.8601 44.4126C34.8601 45.1045 34.7421 45.6628 34.5141 46.1032C34.2861 46.5356 33.9401 46.8973 33.5076 47.1332C33.0673 47.377 32.5247 47.5028 31.8721 47.5028C31.2037 47.5028 30.6533 47.4006 30.2208 47.1883C29.7726 46.9681 29.4031 46.6143 29.1593 46.1818C28.8998 45.7336 28.7583 45.1596 28.7583 44.4676ZM30.5825 44.4834C30.5825 45.0809 30.6926 45.5056 30.9128 45.765C31.133 46.0245 31.4318 46.1582 31.817 46.1582C32.2102 46.1582 32.509 46.0324 32.7292 45.7729C32.9415 45.5213 33.0515 45.0652 33.0515 44.4047C33.0515 43.8464 32.9415 43.4454 32.7134 43.1859C32.4933 42.9343 32.1866 42.8007 31.8013 42.8007C31.4632 42.7928 31.133 42.9343 30.9207 43.1938C30.6926 43.4533 30.5825 43.8779 30.5825 44.4834Z"
        fill="white"
      />
      <path
        d="M39.7687 45.0016L41.365 45.4813C41.2785 45.8902 41.1055 46.2676 40.8617 46.5978C40.6337 46.8966 40.3428 47.1247 40.0046 47.2741C39.6665 47.4235 39.2262 47.5021 38.6994 47.5021C38.0625 47.5021 37.5356 47.4077 37.1346 47.2269C36.7336 47.046 36.3798 46.7158 36.081 46.244C35.79 45.7722 35.6406 45.1746 35.6406 44.4434C35.6406 43.4683 35.9001 42.7213 36.4191 42.1945C36.938 41.6677 37.6693 41.4082 38.6207 41.4082C39.3599 41.4082 39.9496 41.5576 40.3663 41.8564C40.791 42.1552 41.1055 42.6191 41.3099 43.2403L39.7058 43.5941C39.6665 43.4526 39.6115 43.3189 39.5329 43.201C39.4385 43.0673 39.3048 42.9572 39.1554 42.8786C38.6443 42.6348 38.031 42.8 37.7165 43.2639C37.5514 43.5076 37.4649 43.8929 37.4649 44.4276C37.4649 45.0803 37.5671 45.5285 37.7637 45.7722C37.9602 46.016 38.2433 46.1339 38.5971 46.1418C38.9431 46.1418 39.2105 46.0474 39.3835 45.8509C39.5564 45.6621 39.6823 45.3791 39.7687 45.0016Z"
        fill="white"
      />
      <path
        d="M41.8431 41.5193H43.8482L44.8861 43.3278L45.9004 41.5193H47.8819L46.0498 44.3736L48.0549 47.4087H46.0105L44.8468 45.5216L43.683 47.4087H41.6465L43.6752 44.3421L41.8431 41.5193Z"
        fill="white"
      />
    </g>
  </svg>
);
